/* eslint-disable no-fallthrough */
import React, { useEffect, useRef, useState } from 'react';
import { useParams, useSearchParams, useNavigate } from "react-router";
import { InputGroup, FormControl, Container, Button, Dropdown, Tabs, Form, Col, Row, Tab, SplitButton, ButtonGroup, DropdownButton, ToastContainer, Spinner } from 'react-bootstrap';
import { ArticleService } from '../../services/ArticleService';
import { EditionService } from '../../services/EditionService';
import { AnalyseService } from '../../services/AnalyseService';
import DynamicTable from '../../components/table/dynamic-table/DynamicTable';
import Pagination from '../../components/pagination/Pagination';
import SideDetails from '../../components/side-details/SideDetails';
import ClientDetails from '../../components/side-details/client/client-details/ClientDetails';
import ClientEdition from '../../components/side-details/client/client-edition/ClientEdition';
import ColManager from '../../components/table/dynamic-table/col-manager/ColManager';
import Families from '../../components/families/Families';
import './Editions.scss';
import { PreferenceService } from '../../services/PreferenceService';
import ConfirmDialog from '../../components/confirm-dialog/ConfirmDialog';
import ErrorManager from "../../components/error-manager/ErrorManager";
import { GlobalContext } from "../../services/GlobalProvider";
import { formatTableHeadersFromPrefs, granted, getFile } from '../../helper/Helper'
import ClientListInput from "../../components/form-inputs/client-list-input/ClientListInput";
import AnalysesTpl from './templates/AnalysesTpl.jsx';
import TaxesTpl from './templates/TaxesTpl.jsx';
import JsonTpl from './templates/JsonTpl.jsx';
import ReleveClientTpl from './templates/releve-client-tpl/ReleveClientTpl';


const FilterInput = ({ filter, filterName, defaultFilters, setDefaultFilters, memorizedFilters, setMemorizedFilters }) => {

  let defaultValue = ""

  /* Applique la valeur par défaut si le filtre existe dans defaultFilters */
  if (defaultFilters.find(el => (el.filterName === filterName) && (el.operator === filter.operator))?.value) {
    defaultValue = defaultFilters.find(el => (el.filterName === filterName) && (el.operator === filter.operator))?.value
  }

  /* Applique la la valeur par défaut du filtre mémorisé s'il existe */
  if (memorizedFilters.find(el => (el.filterName === filterName) && (el.operator === filter.operator))?.value) {
    defaultValue = memorizedFilters.find(el => (el.filterName === filterName) && (el.operator === filter.operator))?.value
  }

  const [filterValue, setFilterValue] = useState(defaultValue)
  const [inputNameError, setInputNameError] = useState()

  function changeFilter(e) {

    let value = e.target?.value ? e.target?.value : ""

    if (e.target.type == "date") {
      if (value) {
        setInputNameError()
      }else{
        setInputNameError(e.target.name)
        return
      }
    }

    setFilterValue(value)

    if (value) {
      const filterIsDefined = memorizedFilters.some(m => (m.filterName == filterName) && (m.operator == filter.operator))
      if (filterIsDefined) { /* Si le filtre est présent dans memorizedFilters, on modifie sa value */
        let memorizedFiltersCopy = [...memorizedFilters];
        memorizedFiltersCopy.find(el => (el.filterName === filterName && el.operator === filter.operator)).value = value
        setMemorizedFilters(memorizedFiltersCopy);
      } else { /* Si le filtre n'est pas présent dans memorizedFilters, on le crée et on l'ajoute */
        setMemorizedFilters(memorizedFilters => [...memorizedFilters,
        {
          filterName: filterName,
          operator: filter.operator,
          value: value
        }]);
      }
    } else {
      emptyFilter()
    }
  }

  function emptyFilter() {

    setFilterValue("")
    setInputNameError()

    /* Retire le filtre des filtres mémorisés */
    let memorizedFiltersCopy = [...memorizedFilters];
    let memorizedIndex = memorizedFiltersCopy.findIndex(item => (item.filterName == filterName && item.operator == filter.operator));
    if (memorizedIndex > -1) {
      memorizedFiltersCopy.splice(memorizedIndex, 1)
      setMemorizedFilters(memorizedFiltersCopy)
    }

    /* Retire le filtre des filtres par défaut */
    let defaultFiltersCopy = [...defaultFilters];
    let defaultIndex = defaultFiltersCopy.findIndex(item => (item.filterName == filterName && item.operator == filter.operator));
    if (defaultIndex > -1) {
      defaultFiltersCopy.splice(defaultIndex, 1)
      setDefaultFilters(defaultFiltersCopy)
    }
  }

  switch (filter.type) {
    case "date":
      return <>
        <Form.Label>{filter.libelle}</Form.Label>
        <InputGroup className="mb-2 me-2 filter-input" >
          <Form.Control className={(inputNameError == filterName ? "border-2 border-danger" : (filterValue ? "border-2 border-dark" : ""))} name={filterName} defaultValue={filterValue} type="date" onChange={e => changeFilter(e)} />
          {filterValue &&
            <Button variant="dark" className="rounded-end" onClick={emptyFilter}>
              <i className="material-icons">close</i>
            </Button>
          }
          {inputNameError == filterName &&
            <span className="text-danger w-100 ms-1 mt-1">Date non valide</span>
          }
        </InputGroup>

      </>
    case "number":
      return <>
        <Form.Label>{filter.libelle}</Form.Label>
        <InputGroup className="mb-2 me-2 filter-input">
          <Form.Control className={(filterValue ? "border-2 border-dark" : "")} name={filterName} value={filterValue} type="number" onChange={e => changeFilter(e)} />
          {filterValue &&
            <Button variant="dark" onClick={emptyFilter}>
              <i className="material-icons">close</i>
            </Button>
          }
        </InputGroup>
      </>
    case "text":
      return <>
        <Form.Label>{filter.libelle}</Form.Label>
        <InputGroup className="mb-2 me-2 filter-input">
          <Form.Control className={(filterValue ? "border-2 border-dark" : "")} name={filterName} value={filterValue} type="text" onChange={e => changeFilter(e)} />
          {filterValue &&
            <Button variant="dark" onClick={emptyFilter}>
              <i className="material-icons">close</i>
            </Button>
          }
        </InputGroup>
      </>
    case "select":
      return <>
        <Form.Label>{filter.libelle}</Form.Label>
        <InputGroup className="mb-2 me-2 filter-input">
          <Form.Select className={(filterValue ? "border-2 border-dark" : "")} name={filterName} value={filterValue} onChange={e => changeFilter(e)}>
            <option value={""}>- Choisir -</option>
            {filter.options.map(option => (
              <option key={option.value} value={option.value}>{option.libelle}</option>
            ))}
          </Form.Select>
          {filterValue &&
            <Button variant="dark" onClick={emptyFilter}>
              <i className="material-icons">close</i>
            </Button>
          }
        </InputGroup>
      </>
    default:
      return;
  }
}



const Editions = () => {

  const { globalContextLoaded, preferences, parametres, folderDetails, grants, getPreferences } = React.useContext(GlobalContext);

  const [globalError, setGlobalError] = useState()
  const [currentEdition, setCurrentEdition] = useState()
  const [isDataLoading, setIsDataLoading] = useState(false)
  const [isFileLoading, setIsFileLoading] = useState(false)
  /* const [isForceRegenerateChecked, setIsForceRegenerateChecked] = useState(false) */
  const [data, setData] = useState()
  const [defaultFilters, setDefaultFilters] = useState([
    {
      "filterName": "filter[date]",
      "operator": ">=",
      "value": new Date().toISOString().substring(0, 10)
    },
    {
      "filterName": "filter[date]",
      "operator": "<=",
      "value": new Date().toISOString().substring(0, 10)
    },
    {
      "filterName": "filter[client.type]",
      "operator": "=",
      "value": "debit"
    }
  ])
  const [memorizedFilters, setMemorizedFilters] = useState(defaultFilters)
  const [exportsComptableList, setExportsComptableList] = useState([
    {
      id: "analyses/exportcomptable",
      template: "JsonTpl",
      standAloneTemplate: false,
      label: "Générer les écritures comptables",
      description: "",
      APIUrl: "analyses/exportcomptable",
      grant: "factures.consult",
      requests: {
        downloadBtn: {
          type: "analyse",
          format: "json",
          fileOutput: true,
          dropdown: [
            {
              type: "analyse",
              format: "csv",
              fileOutput: true,
            }
          ]
        },
        displayBtn: {
          type: "analyse",
          format: "json",
          fileOutput: false
        }
      },
      filters: {
        'filter[date]': [
          { libelle: 'Date début', operator: ">=", type: 'date' },
          { libelle: 'Date fin', operator: "<=", type: 'date' }
        ],
        'filter[client.tag]': [
          { libelle: 'Tag client (Indisponible)', operator: "=", type: 'text' }
        ],
      },
      params: [
        { name: "force_regenerate", label: "Re-générer en compta les factures déjà archivées", type: "boolean", value: false }
      ]
    },
  ])

  const [analyseList, setAnalyseList] = useState([
    {
      id: "analyses/ventesfacturesperiode",
      template: "AnalysesTpl",
      standAloneTemplate: false,
      label: "Analyse des ventes par période",
      description: "Journal factures / période : Total des factures débit et comptant par période",
      APIUrl: "analyses/ventesfacturesperiode",
      grant: "factures.consult",
      requests: {
        downloadBtn: {
          type: "edition",
          format: "pdf",
          fileOutput: true,
          dropdown: [
            {
              type: "edition",
              format: "xls",
              fileOutput: true,
            }
          ]
        },
        displayBtn: {
          type: "analyse",
          format: null,
          fileOutput: false
        }
      },
      filters: {
        'filter[date]': [
          { libelle: 'Date début', operator: ">=", type: 'date' },
          { libelle: 'Date fin', operator: "<=", type: 'date' }
        ],
        'filter[client.type]': [
          { libelle: 'Type client', operator: "=", type: 'select', options: [{ libelle: "Comptant", value: "comptant" }, { libelle: "Débit", value: "debit" }, { libelle: "Interne", value: "interne" }] }
        ],
        'filter[client.code]': [
          { libelle: 'Code client du (Indisponible)', operator: ">", type: 'text' },
          { libelle: 'au (Indisponible)', operator: "<", type: 'text' }
        ],
        'filter[client.tag]': [
          { libelle: 'Tag client (Indisponible)', operator: "=", type: 'text' }
        ],
        'filter[vendeur]': [
          { libelle: 'Vendeur', operator: "=", type: 'text' }
        ]
      },
      params: []
    },
    {
      id: "analyses/rapporttaxes",
      template: "TaxesTpl",
      standAloneTemplate: false,
      label: "Récapitulatif des taxes",
      description: "Rapport de collecte des taxes à la vente",
      APIUrl: "analyses/rapporttaxes",
      grant: "contributions",
      requests: {
        downloadBtn: {
          type: "edition",
          format: "pdf",
          fileOutput: true,
          dropdown: [
            {
              type: "edition",
              format: "xls",
              fileOutput: true,
            }
          ]
        },
        displayBtn: {
          type: "analyse",
          format: null,
          fileOutput: false
        }
      },
      filters: {
        'filter[date]': [
          { libelle: 'Date début', operator: ">=", type: 'date' },
          { libelle: 'Date fin', operator: "<=", type: 'date' }
        ]
      },
      params: [
        { name: "globaliser", label: "Globaliser les résultats", type: "boolean", value: false }
      ]
    },
    /* {
      id: "analyses/relevesclients",
      template: "ReleveClientTpl",
      standAloneTemplate: false,
      label: "Relevés comptable clients",
      description: "Récapitule l'ensemble des opérations ayant eu lieu sur le compte, pendant une période donnée",
      APIUrl: "analyses/relevesclients",
      grant: "clients",
      requests: {
        downloadBtn: {
          type: "edition",
          format: "pdf",
          fileOutput: true,
          dropdown: [
            {
              type: "edition",
              format: "xls",
              fileOutput: true,
            }
          ]
        }
      },
      filters: {
        'filter[date]': [
          { libelle: 'Date début', operator: ">=", type: 'date' },
          { libelle: 'Date fin', operator: "<=", type: 'date' }
        ]
      },
      params: [
        { name: "clients", label: "Clients", type: "clientList", value: "8d240699c2" },
        { name: "include_lettrees", label: "Inclure lettrées", type: "boolean", value: false },
        { name: "include_soldes", label: "Inclure soldés", type: "boolean", value: false }
      ]
    }, */
    {
      id: "analyses/relevesclients",
      template: "ReleveClientTpl",
      standAloneTemplate: true,
      label: "Relevés comptable clients",
      description: "Récapitule l'ensemble des opérations ayant eu lieu sur le compte, pendant une période donnée",
      grant: "clients"
    }
  ])

  useEffect(() => {
    if (granted(grants, exportsComptableList[0].grant)) {
      changeCurrentEdition(exportsComptableList[0])
    }
  }, [])

  function getEditions(format, fileOutput) {

    fileOutput ? setIsFileLoading(true) : setIsDataLoading(true)

    let memorizedFiltersCopy = [...memorizedFilters];
    let filtersToSend = {}

    Object.keys(currentEdition.filters).map((key, i) => {
      filtersToSend[key] = []
      for (let filter of currentEdition.filters[key]) {
        let filterFound = memorizedFiltersCopy.find(el => (el.filterName === key && el.operator === filter.operator))
        if (filterFound) {
          filtersToSend[key].push({
            "operator": filterFound.operator,
            "value": filterFound.value
          })
        }
      }
    })

    Object.keys(filtersToSend).map((key) => {
      if (filtersToSend[key].length == 0) {
        delete filtersToSend[key]
      }
    })

    let params = {
      'filters': filtersToSend,
      'file_output': fileOutput ? true : false
    }

    for (let param of currentEdition.params) {
      params[param.name] = param.value
    }

    EditionService.getEditions(folderDetails?.dossier?._id, params, currentEdition.APIUrl, format).then(res => {
      if (res.status == 204 || !res?.data) {
        setData()
        setGlobalError({ statusText: `Aucun résultat n'a été trouvé (${res.statusText})` })
      } else {
        setGlobalError()
        if (fileOutput) {
          getFile(res, format)
        } else {
          setData(res.data)
        }
      }
      setIsDataLoading(false)
      setIsFileLoading(false)
    }).catch(error => {
      setGlobalError(error)
      setIsDataLoading(false)
      setIsFileLoading(false)
    });
  }

  function getAnalyses(format, fileOutput) {

    fileOutput ? setIsFileLoading(true) : setIsDataLoading(true)

    let memorizedFiltersCopy = [...memorizedFilters];
    let filtersToSend = {}

    Object.keys(currentEdition.filters).map((key, i) => {
      filtersToSend[key] = []
      for (let filter of currentEdition.filters[key]) {
        let filterFound = memorizedFiltersCopy.find(el => (el.filterName === key && el.operator === filter.operator))
        if (filterFound) {
          filtersToSend[key].push({
            "operator": filterFound.operator,
            "value": filterFound.value
          })
        }
      }
    })

    Object.keys(filtersToSend).map((key) => {
      if (filtersToSend[key].length == 0) {
        delete filtersToSend[key]
      }
    })

    let params = {
      'filters': filtersToSend,
      'file_output': fileOutput ? true : false
    }

    for (let param of currentEdition.params) {
      params[param.name] = param.value
    }

    AnalyseService.getAnalyses(folderDetails?.dossier?._id, params, currentEdition.APIUrl, format).then(res => {
      if (res.status == 204 || !res?.data) {
        setData()
        setGlobalError({ statusText: `Aucun résultat n'a été trouvé (${res.statusText})` })
      } else {
        setGlobalError()
        if (fileOutput) {
          getFile(res, format)
        } else {
          setData(res.data)
        }
      }
      setIsDataLoading(false)
      setIsFileLoading(false)
    }).catch(error => {
      setGlobalError(error)
      setIsDataLoading(false)
      setIsFileLoading(false)
    });
  }

  /*   function getEditions(editionType, format, asFile) {
  
      asFile ? setIsFileLoading(true) : setIsDataLoading(true)
  
      let memorizedFiltersCopy = [...memorizedFilters];
      let filtersToSend = {}
  
      Object.keys(currentEdition.filters).map((key, i) => {
        filtersToSend[key] = []
        for (let filter of currentEdition.filters[key]) {
          let filterFound = memorizedFiltersCopy.find(el => (el.filterName === key && el.operator === filter.operator))
          if (filterFound) {
            filtersToSend[key].push({
              "operator": filterFound.operator,
              "value": filterFound.value
            })
          }
        }
      })
  
      Object.keys(filtersToSend).map((key) => {
        if (filtersToSend[key].length == 0) {
          delete filtersToSend[key]
        }
      })
  
      let params = {
        'filters': filtersToSend,
        'file_output': asFile ? true : false
      }
  
      for (let param of currentEdition.params) {
        params[param.name] = param.value
      }
      
      let service = null
      if (editionType == "Export") {
        service = EditionService.getEditionsExport
      } else if (editionType == "Analyse") {
        service = EditionService.getEditionsAnalyses
      }
  
      service(folderDetails?.dossier?._id, params, currentEdition.APIUrl, format ? format : null).then(res => {
        if (res.status == 204 || !res?.data) {
          setEditionData()
          setGlobalError({ statusText: `Aucun résultat n'a été trouvé (${res.statusText})` })
        } else {
          setGlobalError()
          if (asFile) {
            getFile(res, format)
          } else {
            setEditionData(res.data)
          }
        }
        setIsDataLoading(false)
        setIsFileLoading(false)
      }).catch(error => {
        setGlobalError(error)
        setIsDataLoading(false)
        setIsFileLoading(false)
      });
    } */

  function changeCurrentEdition(edition) {
    setData()
    setCurrentEdition(edition)
  }

  function changeParams(e) {
    let param = currentEdition.params.find(p => p.name === e.target.name)
    let value
    e.target.type == "checkbox" ? value = e.target.checked : value = e.target.value
    param.value = value
  }

  return (
    <Container fluid id="Editions">

      <ErrorManager error={globalError} fixed="true" />

      <Row>

        <Col xs="12" sm="5" lg="4" xl="3" xxl="2" className="py-4">

          {exportsComptableList.filter(exportComptable => granted(grants, exportComptable.grant)).length > 0 ?
            <h5 className="">Exports comptable</h5>
            :
            <div className="">
              <h5 className="">Exports comptable</h5>
              <em className="bg-gray-100 text-gray-600 p-2 w-100 rounded">- Vous n'avez aucun des droits nécessaires pour consulter les exports comptable. -</em>
            </div>
          }

          {exportsComptableList.map(exportComptable => (
            <div key={exportComptable.id}>
              {granted(grants, exportComptable.grant) &&
                <div onClick={() => changeCurrentEdition(exportComptable)} className={"cursor-pointer p-3 rounded border mb-2 " + (currentEdition?.id == exportComptable.id ? "bg-primary-200 text-primary-900" : "hover-bg-gray-100")}>
                  <h6>{exportComptable.label}</h6>
                  <p className="m-0 fw-light">{exportComptable.description}</p>
                </div>
              }
            </div>

          ))}

          {analyseList.filter(analyse => granted(grants, analyse.grant)).length > 0 ?
            <h5 className="mt-4">Analyses</h5>
            :
            <div className="">
              <h5 className="mt-4">Analyses</h5>
              <em className="bg-gray-100 text-gray-600 p-2 w-100 rounded">- Vous n'avez aucun des droits nécessaires pour consulter les analyses de vente. -</em>
            </div>
          }

          {analyseList.map(analyse => (
            <div key={analyse.id}>
              {granted(grants, analyse.grant) &&
                <div onClick={() => changeCurrentEdition(analyse)} className={"cursor-pointer p-3 rounded border mb-2 " + (currentEdition?.id == analyse.id ? "bg-primary-200 text-primary-900" : "hover-bg-gray-100")}>
                  <h6>{analyse.label}</h6>
                  <p className="m-0 fw-light">{analyse.description}</p>
                </div>
              }
            </div>
          ))}

        </Col>

        {(currentEdition && !currentEdition.standAloneTemplate) &&
          <Col xs="12" sm="7" lg="8" xl="9" xxl="10" className="py-4 ps-lg-4">
            <Row className="">
              <Col xs="12" xl="auto" className="d-flex align-items-center">
                <h4>{currentEdition.label}</h4>
              </Col>
              <Col xs="12" xl="auto" className="ms-auto">
                {currentEdition.id == "analyses/exportcomptable" &&
                  <>
                    <Button disabled={isDataLoading} variant="secondary" onClick={() => getAnalyses("json")}>
                      Afficher les résultats {currentEdition.id}
                    </Button>
                    <ButtonGroup>
                      <Button disabled={isFileLoading} className="ms-2" onClick={() => getAnalyses("json", true)}>
                        {isFileLoading &&
                          <Spinner animation="border" size="sm" className="me-2" />
                        }
                        Télécharger le Json
                      </Button>
                      <DropdownButton as={ButtonGroup} disabled={isFileLoading} title="">
                        <Dropdown.Item onClick={() => getAnalyses("csv", true)}>Télécharger en csv</Dropdown.Item>
                      </DropdownButton>
                    </ButtonGroup>
                  </>
                }
                {(currentEdition.id == "analyses/ventesfacturesperiode" || currentEdition.id == "analyses/rapporttaxes" || currentEdition.id == "analyses/relevesclients") &&
                  <>
                    <Button disabled={isDataLoading} variant="secondary" onClick={() => getAnalyses()}>
                      Afficher les résultats {currentEdition.id}
                    </Button>
                    <ButtonGroup>
                      <Button disabled={isFileLoading} className="ms-2" onClick={() => getEditions("pdf", true)}>
                        {isFileLoading &&
                          <Spinner animation="border" size="sm" className="me-2" />
                        }
                        Télécharger le PDF
                      </Button>
                      <DropdownButton as={ButtonGroup} disabled={isFileLoading} title="">
                        <Dropdown.Item onClick={() => getEditions("xls", true)}>Télécharger en xls</Dropdown.Item>
                      </DropdownButton>
                    </ButtonGroup>
                  </>
                }
              </Col>
            </Row>

            {Object.keys(currentEdition.filters).length > 0 &&
              <Row className="pt-4">
                <Col>
                  <h6>Filtres :</h6>
                  {Object.keys(currentEdition.filters).map((key, i) => (
                    <span className="input-container ps-2 pt-2 bg-gray-100 me-2 rounded d-inline-flex mb-2" key={i}>
                      {currentEdition.filters[key].map((filter, j) => (
                        <div key={j}>
                          <FilterInput filter={filter} filterName={key} defaultFilters={defaultFilters} setDefaultFilters={setDefaultFilters} memorizedFilters={memorizedFilters} setMemorizedFilters={setMemorizedFilters} />
                        </div>
                      ))}
                    </span>
                  ))}
                </Col>
              </Row>
            }

            {currentEdition.params.length > 0 &&
              <Row className="pt-4">
                <Col>
                  <h6>Paramètres :</h6>
                  {currentEdition.params && currentEdition.params.map((param, i) => (
                    <span className="input-container p-2 bg-gray-100 me-2 rounded d-inline-flex mb-2" key={i}>
                      {param.type == "boolean" &&
                        <Form.Check
                          className="m-0 me-2"
                          type="checkbox"
                          name={param.name}
                          defaultChecked={param.value}
                          onClick={changeParams}
                          label={param.label}
                        />
                      }
                      {param.type == "text" &&
                        <Form.Control
                          className="m-0"
                          type="text"
                          placeholder=""
                          name={param.name}
                          defaultValue={param.value}
                          onChange={changeParams}
                        />
                      }
                      {param.type == "clientList" &&
                        <span className="m-0 client-list-param">
                          <p className="mb-1">Clients</p>
                          <ClientListInput name={param.name} folderId={folderDetails?.dossier?._id} onClientIdListChange={changeParams} />
                        </span>
                      }
                    </span>
                  ))}
                </Col>
              </Row>
            }
            <Row className="pt-4">
              <Col>

                {/* <p className="text-gray-500">Résultats de la recherche...</p> */}

                {isDataLoading &&
                  <span className="hloader"></span>
                }

                {(!isDataLoading && data) &&
                  <>
                    {currentEdition?.template == "AnalysesTpl" &&
                      <AnalysesTpl data={data} currentEdition={currentEdition} />
                    }
                    {currentEdition?.template == "TaxesTpl" &&
                      <TaxesTpl data={data} currentEdition={currentEdition} />
                    }
                    {currentEdition?.template == "JsonTpl" &&
                      <JsonTpl data={data} currentEdition={currentEdition} />
                    }
                  </>
                }

              </Col>
            </Row>
          </Col>
        }

        {(currentEdition && currentEdition.standAloneTemplate) &&
          <Col xs="12" sm="7" lg="8" xl="9" xxl="10" className="py-4 ps-lg-4 pt-4">
            {currentEdition?.template == "ReleveClientTpl" &&
              <ReleveClientTpl currentEdition={currentEdition} />
            }
          </Col>
        }
      </Row>

    </Container>

  );
}

export default Editions;